import React from 'react';
import PropTypes from 'prop-types';
import { UserComment } from 'site-modules/dealerships/components/user-comment/user-comment';
import { ReviewEntities } from 'client/data/models/dealer-reviews';

export function UserCommentsList({ comments }) {
  return (
    <ul className="user-comments-list list-unstyled mb-0">
      {comments.map(item => (
        <li key={item.id} className="mb-1">
          <UserComment comment={item} />
        </li>
      ))}
    </ul>
  );
}

UserCommentsList.propTypes = {
  comments: PropTypes.arrayOf(ReviewEntities.CommentsEntity).isRequired,
};
